
import { Box, IconButton, TableCell, TableRow } from '@mui/material'
import ClinicApi, { BranchInterface } from 'api/master/clinic.api'
import { showModal } from 'app/slice/modal.slice'
import InputCheckbox from 'component/Input/InputCheckbox'
import InputTextField from 'component/Input/InputTextField'
import AutocompleteSelect from 'component/Select/AutocompleteSelect'
import TableCustom from 'component/Table/TableCustom'
import TableRowCommon from 'component/Table/TableRowCommon'
import { notiError, notiSuccess } from 'component/notifications/notifications'
import { icons } from 'constants/images'
import { colors } from 'constants/theme'
import { ListFilterDoctors } from 'features/counter/appointment/head-appointment'
import MainButton from 'new-components/buttons/main-button'
import TextInput from 'new-components/inputs/text-input'
import PageModal from 'new-components/modal/page-modal'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { numberOnly, numberOnlyDecimal, stripLeadingZeros } from 'utils/app.utils'

type FormOpetaivesBranchProps = {
    onCloseModalManageBranch: () => void
    manageBranch: any
    handleChangeManageBranch: (value: dataManageProps) => void
    handleChangeOperativePrice: (event: any) => void
    operativeSalePrice: string
    errorMessage: any
    setErrorMessage: (value: any) => void
    state?: boolean
    isPriceRange?: '0' | '1'
}

export type dataManageProps = {
    branches: dataManageBranchesProps[] | []
    defaultPrice: string | number | undefined
}

export type dataManageBranchesProps = {
    branchId: number[]
    price: string | number
    minPrice?: string | number | null
    maxPrice?: string | number | null
}

export const initDataManage = {
    branches: [],
    defaultPrice: ''
}

const FormOpetaivesBranch = (props: FormOpetaivesBranchProps) => {

    const { onCloseModalManageBranch, manageBranch, handleChangeManageBranch, operativeSalePrice, handleChangeOperativePrice, errorMessage, setErrorMessage, isPriceRange = '0' } = props

    const { t } = useTranslation()
    const modal = useSelector(showModal)

    const [branches, setBranches] = useState<BranchInterface[]>([])
    const [page, setPage] = useState<number>(1)
    const [pageLimit, setPageLimit] = useState<number>(10)
    const [sortType, setSortType] = useState<string>('ASC')

    const [dataManage, setDataManage] = useState<dataManageProps>(initDataManage)
    const [selectBranch, setSelectBranch] = useState<number[]>([])
    const [errorDataManage, setErrorDataManage] = useState<boolean>(false)
    const [temp, setTemp] = useState<any>(null)
    const loadData = () => {
        // ClinicApi.findAllBranches().then(({ data }) => setBranches(data))
        ClinicApi.findAllActiveBranches().then(({ data }) => data && setBranches(data))
    }

    useEffect(() => {
        loadData()
    }, [])

    const onChangeManageBranch = (value: dataManageBranchesProps | undefined, index: number, nameElement: string) => {
        if (nameElement === 'branches' && value) {
            const temp = [...dataManage?.branches]
            temp[index] = value
            setDataManage({ ...dataManage, [nameElement]: temp })
        }
    }

    const onDelManageBranch = (index: number) => {
        const newData = dataManage?.branches?.filter((item: any, idx: number) => index !== idx)
        setErrorDataManage(false)
        setErrorMessage({
            ...errorMessage,
            ...{
                OPERATIVE_SALE_PRICE: '',
                SALE_PRICE_ANY_REQUIRED: '',
                SALE_PRICE_NUMBER: '',
                EMPTY_OPERATIVE_SALE: ''
            }
        })
        setDataManage({ ...dataManage, ['branches']: newData })
    }

    const headCells = [
        { id: 'branch', disablePadding: false, label: t('OPERATIVE.BRANCH_PRICE.BRANCH'), class: 'text-nowrap', width: isPriceRange === '1' ? '25%' : '40%' },
        { id: 'price', disablePadding: false, label: t('OPERATIVE.BRANCH_PRICE.PRICE_BATH'), class: 'text-nowrap', width: isPriceRange === '1' ? '20%' : '40%', align: 'center' },
        ...(isPriceRange === '1' ? [
            { id: 'minPrice', disablePadding: false, label: t('OPERATIVE.BRANCH_PRICE.MIN_PRICE') || 'ราคาขั้นต่ำ', class: 'text-nowrap', width: '20%', align: 'center' },
            { id: 'maxPrice', disablePadding: false, label: t('OPERATIVE.BRANCH_PRICE.MAX_PRICE') || 'ราคาขั้นสูงสุด', class: 'text-nowrap', width: '20%', align: 'center' },
        ] : []),
        { id: 'action', disablePadding: false, label: t('Action'), class: 'text-nowrap', width: '10%' },
    ]

    const onCheckBranchId = (branch: BranchInterface) => {
        const check = selectBranch.some((item: number) => item === branch.branchId)
        return check
    }

    const onChangeBranch = (item: any, index: number, branch: BranchInterface | "ALL") => {
        setErrorDataManage(false)
        if (branch === "ALL") {
            const allBranchIds = branches.map((b) => b.branchId);

            // หา branchId ที่ array อื่นเลือกไปแล้ว
            const usedBranchIds = dataManage.branches
                .filter((_, i) => i !== index) // ยกเว้นตัวที่กำลังแก้ไข
                .flatMap((d) => d.branchId || []);

            // เอา branchId ที่ยังว่างอยู่มาใช้
            const availableBranchIds = allBranchIds.filter(
                (id) => !usedBranchIds.includes(id)
            );
            const isAllSelected =
                item.branchId?.length === availableBranchIds.length &&
                availableBranchIds.every((id) => item.branchId.includes(id));
            const newValue = {
                ...item,
                branchId: isAllSelected ? [] : availableBranchIds,
            };
            onChangeManageBranch(newValue, index, "branches");
            return;
        }
        let uniqueArray: number[] = []
        if (item?.branchId) {
            if (item?.branchId.includes(branch.branchId)) {
                uniqueArray = item.branchId.filter((item: number) => item !== branch.branchId)
            } else {
                uniqueArray = [...item?.branchId, branch.branchId]
            }
        } else {
            uniqueArray = [branch.branchId]
        }

        const newValue = { ...item, branchId: uniqueArray }
        onChangeManageBranch(newValue, index, 'branches')
    }

    const onCheckDisabled = (
        item: any,
        branch: BranchInterface | "ALL",
        index?: number
    ) => {
        // เช็คว่ามี array ไหนเลือก ALL อยู่หรือไม่
        const allBranchIds = branches.map(b => b.branchId)
        const indexWithAllSelected = dataManage?.branches.findIndex(d =>
            d.branchId?.length === allBranchIds.length
        )
        // ถ้ามีการเลือก ALL ใน array อื่น → disable ทุกอย่าง
        if (indexWithAllSelected !== -1) {
            // ยกเว้นปุ่ม ALL ของ array ที่เลือกไว้ เพื่อให้ยกเลิกได้
            if (indexWithAllSelected === index && branch === "ALL") {
                return false
            }
            return true
        }
        if (branch !== "ALL" && typeof branch !== "string") {
            const check = selectBranch.includes(branch.branchId)
            const itemCheck = item?.branchId
                ? !item?.branchId.includes(branch.branchId)
                : true
            return check && itemCheck
        }

        return false
    }


    const renderData = () => {

        return dataManage?.branches?.map((item: any, index: number) => {
            return (
                <TableRowCommon
                    key={String(index + 1)}
                    id={String(index + 1)}
                    obj={dataManage}
                    columns={[
                        {
                            option: 'COMPONENT',
                            component: (
                                <Box sx={{ '.MuiAutocomplete-popper': { transform: `unset !important`, inset: `unset !important` } }} >
                                    <AutocompleteSelect
                                        labelId="branches"
                                        key={`branches-${index}`}
                                        inputLabel={t('OPERATIVE.BRANCH_PRICE.BRANCH')}
                                        options={['ALL', ...branches]}
                                        getOptionLabel={(option: any) => `${option?.branchId || ''}`}
                                        noOptionsText={t('REGISTER.FORM.NOT_FOUND')}
                                        renderOption={(props, option) => {
                                            if (option === 'ALL') {
                                                return (
                                                    <ListFilterDoctors
                                                        {...props}
                                                        key={option}
                                                        component="li"
                                                        value={option}
                                                        onClick={() => {
                                                            !onCheckDisabled(item, option, index) && onChangeBranch(item, index, option)
                                                        }}
                                                    >
                                                        <InputCheckbox
                                                            label={t('ALL')}
                                                            checked={selectBranch?.length === branches?.length}
                                                            indeterminate={selectBranch?.length >= 1 && selectBranch?.length !== branches?.length}
                                                            className={'pe-none'}
                                                            disabled={onCheckDisabled(item, option, index)}
                                                        />
                                                    </ListFilterDoctors>
                                                )
                                            } else {
                                                return (
                                                    <ListFilterDoctors
                                                        {...props}
                                                        key={option.dentistId}
                                                        component="li"
                                                        value={option.dentistId}
                                                        onClick={() => !onCheckDisabled(item, option) && onChangeBranch(item, index, option)}
                                                    >
                                                        <InputCheckbox
                                                            label={option.branchName}
                                                            checked={onCheckBranchId(option)}
                                                            className={'pe-none'}
                                                            disabled={onCheckDisabled(item, option)}
                                                        />
                                                    </ListFilterDoctors>
                                                )
                                            }
                                        }}
                                        renderTags={(tagValue, getTagProps) => {
                                            return (
                                                <>
                                                    <Box className='d-flex flex-wrap'>
                                                        {
                                                            tagValue.map((option: any, index: number) => {
                                                                return (
                                                                    <Box key={index}>
                                                                        {branches.find((item) => option === item?.branchId)?.branchName || ''}{(item?.branchId?.length || 1) - 1 !== index && ', '}
                                                                    </Box>
                                                                )
                                                            })
                                                        }
                                                    </Box>
                                                </>
                                            )
                                        }}
                                        filterOptions={(option) => 'ALL' + option?.branchName || ''}
                                        value={item?.branchId || []}
                                        required
                                        multiple
                                        disableClearable
                                        errMessage={errorDataManage && item?.branchId?.length === 0 ? t('OPERATIVE.BRANCH_PRICE.ERROR.BRANCH') : ''}
                                    />
                                </Box>
                            )
                        },
                        {
                            option: 'COMPONENT',
                            component: (
                                <Box sx={{ textAlign: 'center', '.MuiFormControl-root': { maxWidth: isPriceRange === '1' ? '120px' : '160px' } }}>
                                    <InputTextField
                                        key={`branch-price`}
                                        onchange={(event) => {
                                            if (event.target.value === '') {
                                                const newValue = { ...item, price: 0 }
                                                onChangeManageBranch(newValue, index, 'branches')
                                                return
                                            }
                                            const newValue = { ...item, price: numberOnly(event) }
                                            onChangeManageBranch(newValue, index, 'branches')
                                        }}
                                        label={t('')}
                                        value={item?.price || ''}
                                        required
                                        disabled={!item?.branchId}
                                    />
                                </Box>
                            )
                        },
                        ...(isPriceRange === '1' ? [
                            {
                                option: 'COMPONENT',
                                component: (
                                    <Box sx={{ textAlign: 'center', '.MuiFormControl-root': { maxWidth: '120px' } }}>
                                        <InputTextField
                                            key={`branch-min-price`}
                                            onchange={(event: any) => {
                                                const newValue = { ...item, minPrice: event.target.value === '' ? null : numberOnly(event) }
                                                onChangeManageBranch(newValue, index, 'branches')
                                            }}
                                            label={t('')}
                                            value={item?.minPrice || ''}
                                            disabled={!item?.branchId}
                                        />
                                    </Box>
                                )
                            },
                            {
                                option: 'COMPONENT',
                                component: (
                                    <Box sx={{ textAlign: 'center', '.MuiFormControl-root': { maxWidth: '120px' } }}>
                                        <InputTextField
                                            key={`branch-max-price`}
                                            onchange={(event: any) => {
                                                const newValue = { ...item, maxPrice: event.target.value === '' ? null : numberOnly(event) }
                                                onChangeManageBranch(newValue, index, 'branches')
                                            }}
                                            label={t('')}
                                            value={item?.maxPrice || ''}
                                            disabled={!item?.branchId}
                                        />
                                    </Box>
                                )
                            }
                        ] : []),
                        {
                            option: 'COMPONENT',
                            component: (
                                <Box sx={{ textAlign: 'center' }}>
                                    <IconButton onClick={() => onDelManageBranch(index)}>
                                        <img src={icons.btnTrash} alt="trash" />
                                    </IconButton>
                                </Box>
                            )
                        }
                    ]}
                />
            )
        }) || []
    }

    const handleAddManageBranch = () => {
        if (dataManage?.branches?.length >= branches?.length) {
            return
        }

        const dataBranch: dataManageBranchesProps[] = dataManage?.branches ? [...dataManage.branches, { branchId: [], price: '', minPrice: null, maxPrice: null }] : []
        const newData: dataManageProps = { ...dataManage, branches: dataBranch }
        setDataManage(newData)
    }

    const renderAddData = () => {
        return [
            <TableRow key={String(0)}>
                <TableCell colSpan={isPriceRange === '1' ? 5 : 3}>
                    <Box sx={{ display: 'flex', alignItems: 'center', }} >
                        <Box
                            sx={{
                                display: 'flex',
                                alignItems: 'center',
                                cursor: 'pointer',
                                color: dataManage?.branches?.length >= 10 ? colors.textExtraLightGray : colors.themeSecondColor,
                            }}
                            onClick={() => {
                                if (dataManage?.branches?.length <= 10) {
                                    handleAddManageBranch()
                                }
                            }}
                        >
                            <Box sx={{
                                fontSize: '24px',
                                margin: '-8px 8px 0 0'
                            }} >+</Box>
                            <Box>
                                {t('OPERATIVE.BRANCH_PRICE.ADD_BRANCH')}
                            </Box>
                        </Box>
                    </Box>
                </TableCell>
            </TableRow>
        ]
    }

    useEffect(() => {
        setDataManage(manageBranch)
        setTemp(manageBranch)
    }, [modal, manageBranch])

    useEffect(() => {
        let newValueBranchId: number[] = []
        dataManage?.branches?.forEach((item: any) => {
            if (item?.branchId) {
                newValueBranchId = [...newValueBranchId, ...item?.branchId]
            }
        })
        if (newValueBranchId) {
            setSelectBranch([...newValueBranchId])
        }
    }, [dataManage])

    const onUpdatePriceBranch = () => {
        if (!dataManage?.branches?.length || !dataManage?.defaultPrice) {
            return
        }

        const newDataBranch = dataManage.branches.map((item: any, index: number) => {
            if (item?.branchId) {
                return { ...item, price: dataManage.defaultPrice }
            } else {
                return item
            }
        })
        setDataManage({ ...dataManage, branches: newDataBranch })
    }

    const onSubmit = () => {
        const check = dataManage?.branches?.some((item) => !item?.price || item?.price === "")
        const branch = dataManage?.branches?.some((item) => item.branchId.length === 0)
        if (check || operativeSalePrice === '' || branch) {
            if (check || branch) {
                setErrorDataManage(true)
                notiError(t('OPERATIVE.BRANCH_PRICE.ERROR.PRICE_BATH'))
            }
            if (operativeSalePrice === '') {
                setErrorMessage({
                    ...errorMessage,
                    ...{
                        EMPTY_OPERATIVE_SALE: !operativeSalePrice ? t('OPERATIVE.MESSAGE.OPERATIVE_SALE_PRICE') : ''
                    }
                })
            }
            return
        }
        setTemp({ ...dataManage, defaultPrice: operativeSalePrice })
        setErrorDataManage(false)
        notiSuccess(t('MODAL_TREATMENT_CONSENT.MESSAGE.SUCCESS.SAVE'))
        handleChangeManageBranch(dataManage)
        onCloseModalManageBranch()
    }
    return (
        <PageModal
            isOpen={props.state || false}
            title={t('OPERATIVE.BRANCH_PRICE.TITLE')}
            size="M"
            overflow={true}
            handleClose={() => {
                onCloseModalManageBranch()
                setDataManage(temp)
            }}
            onCancel={{
                onClick: () => {
                    onCloseModalManageBranch()
                    setErrorDataManage(false)
                    setDataManage(temp)
                    setSelectBranch([])
                    setErrorMessage({
                        ...errorMessage,
                        OPERATIVE_SALE_PRICE: '',
                        SALE_PRICE_ANY_REQUIRED: '',
                        SALE_PRICE_NUMBER: '',
                        EMPTY_OPERATIVE_SALE: ''
                    })
                }
            }}
            onSubmit={{ onClick: onSubmit, title: t('OPERATIVE.BUTTON.SAVE') }}
        >
            <Box sx={{ mt: 2, width: '100%' }}>
                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: { xs: 'column', sm: 'row' },
                        justifyContent: 'space-between',
                        alignItems: { xs: 'stretch', sm: 'center' },
                        gap: 2
                    }}
                >
                    <Box
                        sx={{
                            display: 'flex',
                            flexDirection: { xs: 'column', sm: 'row' },
                            alignItems: { xs: 'stretch', sm: 'center' },
                            gap: 2,
                            width: { xs: '100%', sm: 'auto' },
                            mb: 1
                        }}
                    >
                        <Box component="span">{t('OPERATIVE.BRANCH_PRICE.DEFAULT_PRICE')}</Box>
                        <TextInput
                            onChange={(event) => {
                                let raw = event.target.value
                                if (raw === '') { raw = '' }
                                else if (Number(raw) === 0) raw = '0'
                                else {
                                    const cleaned = stripLeadingZeros(numberOnlyDecimal(raw))
                                    raw = cleaned
                                }
                                const newValue: dataManageProps = { ...dataManage, ['defaultPrice']: raw }
                                setDataManage(newValue)
                            }}
                            label={t('')}
                            value={dataManage?.defaultPrice || ''}
                            required
                        />
                        <Box sx={{ alignSelf: { xs: 'flex-end', sm: 'center' } }}>
                            <MainButton
                                onClick={onUpdatePriceBranch}
                                title={t('OPERATIVE.BRANCH_PRICE.UPDATE_DATA')}
                                type="primary"
                                variant="contained"
                            />
                        </Box>
                    </Box>
                    <TextInput
                        onChange={(event) => {
                            // let raw = event.target.value
                            // if (raw === '') { raw = '' }
                            // else if (Number(raw) === 0) raw = '0'
                            // else {
                            //     const cleaned = stripLeadingZeros(numberOnlyDecimal(raw))
                            //     raw = cleaned
                            // }
                            handleChangeOperativePrice(event)
                        }}
                        value={operativeSalePrice}
                        helperText={errorMessage.OPERATIVE_SALE_PRICE || errorMessage.SALE_PRICE_ANY_REQUIRED || errorMessage.SALE_PRICE_NUMBER || errorMessage.EMPTY_OPERATIVE_SALE}
                        label={t('OPERATIVE.INPUT.OPERATIVE_PRICE_DEFAULT')}
                        required
                    />
                </Box>
                <Box sx={{ pt: 2, width: '100%', overflowX: 'auto' }}>
                    <TableCustom
                        page={page}
                        pageLimit={pageLimit}
                        sortType="ASC"
                        sortBy="id"
                        onSort={() => setSortType('ASC')}
                        setPageLimit={() => setPage(1)}
                        setPage={() => setPageLimit(10)}
                        rowCount={10}
                        headCells={headCells}
                        rowsData={[...renderAddData(), ...renderData()]}
                        hidePagination
                    />
                </Box>
            </Box>
        </PageModal>
    )
}
export default FormOpetaivesBranch